(function () {
    'use strict';

    angular
        .module('AsyncPanel')
        .factory('action-ap-set-component-validation-model', actionFunc);

    function actionFunc($q, lodash) {
        return function(panel, options, eventData, actionData) {
            return $q.when(run());

            function run() {
                const funcName = lodash.get(options, 'funcName', 'setValidationModel');
                if (typeof panel.panelScope.vm[funcName] === typeof function() {}) {
                    let modelPath = 'model';
                    if (lodash.has(options, 'modelPath')) {
                        modelPath = [modelPath, options.modelPath].join('.')
                    }
                    let data = eventData;
                    if (lodash.has(options, 'useActionResponse') && options.useActionResponse === true) {
                        data = actionData;
                    }
                    if (lodash.has(options, 'dataPath')) {
                        data = lodash.get(data, options.dataPath, data);
                    }

                    panel.panelScope.vm[funcName](data);
                    return true;
                }
                return false;
            }
        };
    }
})();